export default function escapeCssSelector(value) {
  return String(value).replace(/[^a-zA-Z0-9_-]/g, (character) => {
    const hex = character.codePointAt(0).toString(16);

    return `\\${hex} `;
  });
}
